import Hls from 'hls.js';

//const baseURL = 'https://vrapp-3dakogmbua-an.a.run.app/audit/demo-video/'
// const baseURL = 'http://localhost:8080/audit/demo-video/'

const baseURL = process.env.VUE_APP_URL + 'demo-video/';

export default {
  setVideo(token: string, path: string, video: HTMLMediaElement): void {
    if (Hls.isSupported()) {
      const hls = new Hls({
        // xhrSetup: function (xhr, url) {
        xhrSetup: function (xhr) {
          xhr.setRequestHeader('Authorization', `Bearer ${token}`);
        },
      });
      hls.loadSource(`${baseURL}${path}`);
      hls.attachMedia(video);
    }
    return;
  },
};
